/** Known non-handle amo contact custom-field keys. Always shown. */
export const CRM_CONTACT_FIELD_KEYS = [
  'должность',
  'город',
  'сфера',
  'опыт',
  'комиссия_партнера',
] as const;

export type CrmContactFieldKey = (typeof CRM_CONTACT_FIELD_KEYS)[number];

const HIDDEN_FIELD_KEYS = new Set([
  'phone',
  'email',
  'whatsapplid_wz',
  'whatsapplid_waapi',
  'tgid',
  'tgusername',
  'telegram',
  'channel',
  'способ_связи',
]);

function isHiddenFieldKey(key: string): boolean {
  const lower = key.toLowerCase();
  if (HIDDEN_FIELD_KEYS.has(lower)) return true;
  return (
    lower.includes('whatsapp') ||
    lower.includes('wazzup') ||
    lower.includes('waapi') ||
    lower.includes('telegram') ||
    lower.startsWith('tg')
  );
}

/** Ordered keys: known first (always), then extras — excluding channels / dropped fields. */
export function contactFieldKeys(fields?: Record<string, string> | null): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const key of CRM_CONTACT_FIELD_KEYS) {
    seen.add(key);
    out.push(key);
  }
  for (const key of Object.keys(fields ?? {})) {
    if (seen.has(key) || isHiddenFieldKey(key)) continue;
    seen.add(key);
    out.push(key);
  }
  return out;
}
